import style from "./EmptySection.module.css";

function EmptySection({ title, description }) {
	return (
		<div className={style.noRatingHolder}>
			<div className={style.reviewHolder}>
				<div className={style.background}></div>
				<div className={style.review}>
					<div className={style.header}>
						<div className={style.user}>
							<div className={style.imgHolder}></div>
							<div className={style.userInfo}>
								<div className={style.name}></div>
								<div className={style.date}></div>
							</div>
						</div>
					</div>
					<div className={style.body}>
						<div className={style.starsHolder}>
							<div className={style.stars}></div>
							<div className={style.text}>
								<span></span>
								<span></span>
							</div>
						</div>
						<div className={style.text}></div>
					</div>
				</div>
			</div>
			<div className={style.noReviewText}>
				<h3>{title}</h3>
				<p>{description}</p>
			</div>
		</div>
	);
}

export default EmptySection;
